export enum CourseProgress {
  UNATTEMPTED = 'Unattempted',
  STARTED = 'Started',
  COMPLETED = 'Completed',
}
